import Header from "../../Home/Header";
import Footer from "../../Home/Footer";

import photo1 from "../../assets/aiglePhotos/aiglePhotos1.jpg"
import photo2 from "../../assets/aiglePhotos/aiglePhotos2.jpg"
import photo3 from "../../assets/aiglePhotos/aiglePhotos3.jpg"
import photo4 from "../../assets/aiglePhotos/aiglePhotos4.jpg"
import photo5 from "../../assets/aiglePhotos/aiglePhotos5.jpg"
import photo6 from "../../assets/aiglePhotos/aiglePhotos6.jpg"
import photo7 from "../../assets/aiglePhotos/aiglePhotos7.jpg"
import photo8 from "../../assets/aiglePhotos/aiglePhotos8.jpg"
import photo9 from "../../assets/aiglePhotos/aiglePhotos9.jpg"
import photo10 from "../../assets/aiglePhotos/aiglePhotos10.jpg"
import photo11 from "../../assets/aiglePhotos/aiglePhotos11.jpg"
import photo12 from "../../assets/aiglePhotos/aiglePhotos12.jpg"
import photo13 from "../../assets/aiglePhotos/aiglePhotos13.jpg"
import photo14 from "../../assets/aiglePhotos/aiglePhotos14.jpg"
import photo15 from "../../assets/aiglePhotos/aiglePhotos15.jpg"
import photo16 from "../../assets/aiglePhotos/aiglePhotos16.jpg"
import photo17 from "../../assets/aiglePhotos/aiglePhotos17.jpg"
import photo18 from "../../assets/aiglePhotos/aiglePhotos18.jpg"
import photo19 from "../../assets/aiglePhotos/aiglePhotos19.jpg"
import photo20 from "../../assets/aiglePhotos/aiglePhotos20.jpg"
import photo21 from "../../assets/aiglePhotos/aiglePhotos21.jpg"
import photo22 from "../../assets/aiglePhotos/aiglePhotos22.jpg"
import photo23 from "../../assets/aiglePhotos/aiglePhotos23.jpg"

function AiglePhotos() {
  return (
    <div className="core">
      <Header />
      <h2 className="titre bloc">Photos de l'érection de l'aigle doré</h2>
      <div className="bloc">
        <h3>Le samedi 1er octobre 2005</h3>
        <div className="photoAigle">
          <h4>Arrivée du cortège en place du Béguinage</h4>
          <img src={photo1}></img>
        </div>
        <div className="photoAigle">
          <h4>Dames de compagnie</h4>
          <img src={photo2}></img>
        </div>
        <div className="photoAigle">
          <h4>Damoiselles de compagnie</h4>
          <img src={photo3}></img>
        </div>
        <div className="photoAigle">
          <h4>Le mambour et les dames de compagnie</h4>
          <img src={photo4}></img>
        </div>
        <div className="photoAigle">
          <h4>Les arbalestriers du Serment de Saint Georges</h4>
          <img src={photo5}></img>
        </div>
        <div className="photoAigle">
          <h4>Dames de compagnie</h4>
          <img src={photo6}></img>
        </div>
        <div className="photoAigle">
          <h4>Arrivée des membres du comité</h4>
          <img src={photo7}></img>
        </div>
        <div className="photoAigle">
          <h4>Les enfants des escoles</h4>
          <img src={photo8}></img>
        </div>
        <div className="photoAigle">
          <h4>Les soeurs grises et les enfants des escoles</h4>
          <img src={photo9}></img>
        </div>
        <div className="photoAigle">
          <h4>La Confrérie du Saint Sacrement et les soeurs grises</h4>
          <img src={photo10}></img>
        </div>
        <div className="photoAigle">
          <h4>le hérault, le commandant des culvériniers et les hallebardiers du comte de Croÿ</h4>
          <img src={photo11}></img>
        </div>
        <div className="photoAigle">
          <h4>L'érection</h4>
          <img src={photo12}></img>
        </div>
        <div className="photoAigle">
          <h4>le voilà en haut de sa perche de chêne</h4>
          <img src={photo13}></img>
        </div>
        <div className="photoAigle">
          <h4>La foule est venue nombreuse</h4>
          <img src={photo14}></img>
        </div>
        <div className="photoAigle">
          <h4>Le maître chien</h4>
          <img src={photo15}></img>
        </div>
        <div className="photoAigle">
          <h4>La populace admirative</h4>
          <img src={photo16}></img>
        </div>
        <div className="photoAigle">
          <h4>les tambours du comte de Croÿ</h4>
          <img src={photo17}></img>
        </div>
        <div className="photoAigle">
          <h4>Roulements de tambour après l'érection</h4>
          <img src={photo18}></img>
        </div>
        <div className="photoAigle">
          <h4>Les arbalestriers du Serment de St Georges</h4>
          <img src={photo19}></img>
        </div>
        <div className="photoAigle">
          <h4>Des dames et Damoiselles de compagnie</h4>
          <img src={photo20}></img>
        </div>
        <div className="photoAigle">
          <h4>Une salve d'honneur à l'aigle et l'empereur</h4>
          <img src={photo21}></img>
        </div>
        <div className="photoAigle">
          <h4>Les monteurs de perche</h4>
          <img src={photo22}></img>
        </div>
        <div className="photoAigle">
          <h4>L'aigle doré</h4>
          <img src={photo23}></img>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default AiglePhotos